/**
 * Fired on `window` by `publishGraph` once a save has landed and the store has
 * re-hydrated. Listeners that need the SAVED graph (not the draft) key off it —
 * today that is the stored ground truth, which follows the human save.
 */
export const GRAPH_SAVED_EVENT = 'graph-saved'

export interface GraphSavedDetail {
  graphId: string
  /** The patch version the save produced. */
  version: number
}

export function dispatchGraphSaved(detail: GraphSavedDetail): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent<GraphSavedDetail>(GRAPH_SAVED_EVENT, { detail }))
}
